import React, { useEffect, useState } from 'react';
import { z } from 'zod';
import { CmsLongTextSchema } from '$cms/types';
import type { ContentComponent } from '$cms/ContentComponent';
import type { SchemaType } from '$util/schema';
import { isTargetingCategoryActive } from '$util/oneTrust';
import { TrackingPixel } from '@/components/atoms/TrackingPixel';

const CmsTrackingPixelSchema = {
  translatedEntities: z.object({
    pixelUrl: CmsLongTextSchema,
  }),
};

export type CmsTrackingPixelTranslatedEntities = SchemaType<
  (typeof CmsTrackingPixelSchema)['translatedEntities']
>;

export const CmsTrackingPixel: ContentComponent<CmsTrackingPixelTranslatedEntities> =
  function CmsTrackingPixel({ translatedEntities }): JSX.Element | false {
    const { pixelUrl } = translatedEntities;

    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
      const consentSetHandler = () => {
        setShouldRender(isTargetingCategoryActive());
      };

      document.body.addEventListener('consent-set', consentSetHandler);

      return () => {
        document.body.removeEventListener('consent-set', consentSetHandler);
      };
    }, []);

    return shouldRender ? <TrackingPixel src={pixelUrl.value} /> : false;
  };

CmsTrackingPixel.displayName = 'CmsTrackingPixel';
CmsTrackingPixel.schema = CmsTrackingPixelSchema;
